module.exports = __webpack_public_path__ + "static/media/moons_comer_brackets-1500.01c18b41.webp";